/* eslint-disable */
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import { Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "./NewProblem.css";

// import Toaster from "../../Toaster/Toaster";
import "react-datepicker/dist/react-datepicker.css";

import { Navigate } from "react-router-dom";
import { LightModeLayout } from "../../Layout/LightModeLayout";

function NewProblem({ NewRelic, ...props }) {
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  const [problemID, setProblemID] = useState("PRB0046278");
  const [problem, setProblem] = useState({ number: "PRB0046278" });

  const [createDisabled, setCreateDisabled] = useState(false);

  const navigate = useNavigate();

  let params = useParams();
  const number = params.id;
  useEffect(() => {
    setProblemID(number);

    let requestOptions = {
      method: "GET",
      headers: { Accept: "application/json" },
    };
  }, [number]);

  const clearError = () => {
    setError("");
  };

  const createPRB = () => {
    const problemURL = "/api/v1/problem";

    let requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        problem: {
          number: problemID,
        },
      }),
    };

    problem.number = problemID;

    fetch(problemURL, requestOptions)
      .then((response) => response.json())
      .then(
        (data) => {
          NewRelic?.addPageAction("Problem.Created", {
            problemNumber: problemID,
          });
          navigate("/problem/edit/" + problemID);
        },
        (error) => {
          NewRelic?.noticeError(error);
          NewRelic?.addPageAction("Problem.CreateFailed", {
            errorMessage: error?.message,
            problemNumber: problemID,
          });
          setError(error);
        }
      );
  };

  return (
    <LightModeLayout>
      <Form>
        <Container>
          <Row>
            <Col>
              <span className="problemNumber">{number}</span>
            </Col>
          </Row>
          <Row className="firstRow">
            <Col>
              <span style={{ fontWeight: "bold" }}>Bad News</span>:
            </Col>
          </Row>
          <Row>
            <Col>
              The document you searched for does not seem to exist. This isn't
              necessarily your fault but it definitely isn't mine either...
            </Col>
          </Row>
          <Row>
            <Col>
              <span style={{ fontWeight: "bold" }}>Good News</span>
            </Col>
          </Row>
          <Row>
            <Col>
              We Can Create it now or you can repeat your search and try to get it
              right this time, please!
            </Col>
          </Row>

          <Row className="firstRow">
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
              <Button
                variant="success"
                onClick={() => {
                  createPRB();
                }}
              >
                Create {number} Now
              </Button>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
              <Button
                variant="primary"
                onClick={() => {
                  navigate("/problems");
                }}
              >
                Search Again
              </Button>
            </Col>
          </Row>
        </Container>
      </Form>
    </LightModeLayout>
  );
}

export default NewProblem;
